interface NativeTabBarInsetOptions {
    isNative: boolean
    supportsNativeTabs?: boolean | null
    os?: string
    osVersion?: string
    bottomObstruction?: number
}

interface NativeTabBarInsets {
    bottomObstruction: number
    scrollBottomInset: number
}

export const getNativeTabBarInsets = ({
    isNative,
    supportsNativeTabs,
    os,
    osVersion,
    bottomObstruction,
}: NativeTabBarInsetOptions): NativeTabBarInsets => {
    if (!isNative || supportsNativeTabs !== true) {
        return { bottomObstruction: 0, scrollBottomInset: 0 }
    }

    const isFloatingTabBar = os === "ios" && Number.parseInt(osVersion ?? "", 10) >= 26
    const resolvedBottomObstruction = bottomObstruction ?? (isFloatingTabBar ? 24 : 0)

    return {
        bottomObstruction: resolvedBottomObstruction,
        scrollBottomInset: resolvedBottomObstruction > 0 ? 8 : 0,
    }
}
